import * as Yup from "yup";
import { minError, maxError } from "../utils";
export default (t => Yup.object().shape({
  amount: Yup.number(),
  password: Yup.string().min(4, minError(t.yourPassword, 4, t.minError, t.characters)).max(50, maxError(t.yourPassword, 50, t.maxError, t.characters))
}));